import { render } from "./ServicoComp.vue?vue&type=template&id=8c23183e&scoped=true"
import script from "./ServicoComp.vue?vue&type=script&lang=js"
export * from "./ServicoComp.vue?vue&type=script&lang=js"

import "./ServicoComp.vue?vue&type=style&index=0&id=8c23183e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c23183e"]])

export default __exports__